import {AfterViewInit, Component, ElementRef, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ActivatedRoute} from '@angular/router';
import {environment} from '../../../environments/environment';
import * as moment from "moment";
import {Session} from "selenium-webdriver";

@Component({
  selector: 'app-searchtimesheet',
  templateUrl: './searchtimesheet.component.html',
  styleUrls: ['./searchtimesheet.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class SearchtimesheetComponent implements OnInit, AfterViewInit  {
  profile_searching = ['CI', 'LEADER'];
  _agent = null;
  usernameSearching;
  dateSearching;
  _nodes = [];
  ProgressState = false;
  agents = [];
  _history: boolean = false
  histories: Array<any> = [];
  @ViewChild('startDate') startDate: any;
  @ViewChild('searchButton') searchButton: any;
  @ViewChild('usernames') usernamesInput: any;
  constructor(private http: HttpClient, private route: ActivatedRoute,private el: ElementRef) {
    this.route.queryParamMap.source.subscribe(result => {
      // console.log('result', result && JSON.parse(result));
      this.usernameSearching = result && result.username ? result.username : undefined;
      this.dateSearching = result && result.dateFiche ? result.dateFiche : undefined;
    });
    this.filterHRBP(this.usernameSearching);
  }

  filter(ev, query) {
    if (ev.keyCode == 13) {
      this.ProgressState = true
      this.http.get(environment.api.mscore + 'employee/search?q=' + query).subscribe((agent: any) => {
          this._nodes = agent.payload.filter(e => this.profile_searching.indexOf(e.profile) > -1);
        },
        error => {
          this.ProgressState = false
        },
        () => {
          this.ProgressState = false
        })
    }
  }

  filterHRBP(query) {
    if(!query) return;
    this.ProgressState = true
    this.http.get(environment.api.mscore + 'employee/search?q=' + query).subscribe((agent: any) => {
        this._nodes = agent.payload.filter(e => this.profile_searching.indexOf(e.profile) > -1);
        this.setAgent(this._nodes[0])
      },
      error => {
        this.ProgressState = false
      },
      () => {
        this.ProgressState = false
      })
  }

  ngOnInit() {
    this.route.queryParamMap.source.subscribe(result => {
      this.usernamesInput.nativeElement.value = result && result.username ? result.username : undefined;;
      this.dateSearching =  result && result.dateFiche ? result.dateFiche : undefined;
    });
  }

  ngAfterViewInit(){
    setTimeout(() => {
        if(this.dateSearching && this.searchButton && this.searchButton._elementRef){
          this.searchButton._elementRef.nativeElement.click();
        }
      }, 500)
   }


  setAgent(node) {
    const {id, userName, firstName, lastName} = node;
    this._agent = null;
    setTimeout(() => {
      this._agent = {
        id: id,
        username: userName,
        firstName: firstName,
        lastName: lastName,
        name: firstName + ' ' + lastName + ' [' + userName + ']',
        periods: [{start: null, end: null}]
      };
    }, 100)
  }

  onActivate(el) {
    console.log(el)
  }

  updateHistoryLocal(date, ids) {
    const history = JSON.parse(sessionStorage.getItem("history") || '{}');
    history[date] = history[date] || [];
    history[date] = Array.from(new Set(history[date].concat(ids)));
    sessionStorage.setItem("history", JSON.stringify(history));
  }

  async onEnter(ev) {
    if(!ev.target.value.length) return;
    if (ev.keyCode == 13) {
      const date = !String(this.startDate.value).length ? null : moment(this.startDate.value).toDate();
      const ids = String(ev.target.value).split(",");
      this.updateHistoryLocal(date || moment(new Date()).subtract(1, 'hours').format("YYYY-MM-DD"), ids)

      this.ProgressState = true

      let users: any = await Promise.all(ids.map(async id => {
        const r =  await this.findUser(id);
        return {key: id, ...r};
      }))
      this.ProgressState = false;

      users = users.map(e => {
        return e.payload && e.payload.length ? e.payload[0] : {key: e.key}
      });
      this.agents = (users || []).map((u: any, id) => {
        const {userName, firstName, lastName, key, outDate} = u || {outDate: null, userName: null, firstName: null, lastName: null, key: null};
        return {
          key,
          id: id,
          username: userName,
          firstName: firstName,
          lastName: lastName,
          defaultDate: date,
          name: firstName + ' ' + lastName + ' [' + userName + ']',
          periods: [{start: null, end: null}],
          outDate
        };
      });
    }
  }

  async findUser(username) {
    return new Promise((r, j) => this.http.get(environment.api.mselastic + '/employee/_all?q=employee/search?q=' + username)
      .subscribe(d => r({
      payload: d
    }), j))
  }

  dispatchEnter(element) {
    element.dispatchEvent(new KeyboardEvent('keyup', ({ keyCode: '13' } as any)));
  }


  async openCsv(ev) {
    const [csv] = Array.from(ev.target.files);
    if(csv) {
     const lastLines = [];
     const content: any = await this.readCsv(csv);
     const array: Array<string> = content.split(/\r\n/gm);
     let map = {};
     let demandeur = null;
     let i = 0;
     let result = [];
     array.forEach((line, idx) => {
        line = line.trim();
        if(line.includes("DEMANDEUR:")) {
          demandeur = line.replace("DEMANDEUR:", '');
          map = {};
        }
        if(demandeur && line.length && !line.includes("DEMANDEUR:")) {
          map[demandeur] = map[demandeur] || {start: null, end: null,file: []};
          map[demandeur].file.push(line);
        }
         if((idx > 0 && array[idx + 1] && array[idx + 1].includes("DEMANDEUR:")) || !array[idx + 1]) {
           result.push(map[demandeur]);
           map = {};
         }
       });
      result.forEach((line) => {
        const dates = Array.from(new Set(line.file.slice(1).map(e => {
          let d = e.split(';')[1];
              d = d.split('/').reverse().join('-');
          return new Date(d);
        })));
        const s = new Date(Math.min.apply(null, dates));
        const e = new Date(Math.max.apply(null, dates));
        s.setDate(s.getDate() - 1);
        e.setDate(e.getDate() + 1);

        line.start = s.toISOString().substr(0, 10)
        line.end = e.toISOString().substr(0, 10);

        let last = line.file[line.file.length - 1];
            last = last.split(';');
            let d = last[1];
                d = d.split('/').reverse().join('-');
                lastLines.push({username: last[0], date: d})
      })
      console.log(result, lastLines);
      ev.target.value = '';
    }
  }

  async readCsv(csv) {
    return new Promise((rs) => {
      const r = new FileReader()
      r.onload = (d: any) => rs(d.target.result);
      r.readAsText(csv)
    })
  }
}



// WEBPACK FOOTER //
// ./src/app/view/searchtimesheet/searchtimesheet.component.ts